import { formatRetry, formatSec } from '@/lib/runFormatters';
import type { ActivityStep } from '@/types/run';

export function ConfigStrip({ step }: { step: ActivityStep }) {
  const items: { label: string; value: string }[] = [];
  if (step.start_to_close_timeout_sec != null) {
    items.push({ label: 'timeout', value: `${formatSec(step.start_to_close_timeout_sec)}` });
  }
  if (step.heartbeat_timeout_sec != null) {
    items.push({ label: 'heartbeat', value: `${formatSec(step.heartbeat_timeout_sec)}` });
  }
  if (step.retry_policy) {
    items.push({ label: 'retry', value: formatRetry(step.retry_policy) });
  }
  if (items.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-muted-foreground">
      {items.map((it) => (
        <span key={it.label}>
          <span className="uppercase tracking-wider opacity-70">{it.label}</span>{' '}
          <span className="font-mono">{it.value}</span>
        </span>
      ))}
    </div>
  );
}
